<template>
    <div class="flex gap-x-2 items-center">
        <div class="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
            <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="step.is_complete" />
            <div v-else class="h-2 w-2 rounded-full bg-gray-300 group-hover:bg-gray-400" />
        </div>

        <span ref="element">
            <a :href="step.url" class="text-indigo-500" v-if="step.url">{{ step.text }}</a>
            <span v-else class="text-gray-500">{{ step.text }}</span>
        </span>
    </div>
</template>
<script>
import { IconCircleCheckFilled } from '@tabler/icons-vue';

export default {
    name: 'OnboardingStep',
    components: {
        IconCircleCheckFilled,
    },
};
</script>
<script setup>
import { useTippy } from 'vue-tippy';
import { ref } from 'vue';

const element = ref();

const props = defineProps({
    step: {
        type: Object,
        required: true,
    },
});

if (props.step.help_text) {
    useTippy(element, {
        content: props.step.help_text,
    });
}
</script>
